import { render, staticRenderFns } from "./MobileInvestimentComponent.vue?vue&type=template&id=a137b89c&lang=pug&"
var script = {}
import style0 from "./MobileInvestimentComponent.vue?vue&type=style&index=0&id=a137b89c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports